export enum CompensationTypeLabel {
  Monthly = '/mo',
  Hourly = '/h',
  Biweekly = '/w',
  Yearly = '/y',
}
